export default {
	styleOverrides: {
		// `maxWidth` is set to **at most** `1440px`. See changelog ## 1.0.0-alpha.6
		maxWidthXl: ({ theme }) => ({
			[theme.breakpoints.up('lg')]: {
				maxWidth: '1440px',
			},
		}),
		root: ({ ownerState, theme }) => ({
			...(theme.themeKey === 'internal' &&
				ownerState.variant === 'EvePageContent' && {
					[theme.breakpoints.down('xl')]: {
						padding: 0,
					},
				}),
			...(ownerState.variant === 'EveFullPage' && {
				paddingTop: theme.spacing(3),
				paddingBottom: theme.spacing(3),
				paddingLeft: theme.spacing(6),
				paddingRight: theme.spacing(6),
			}),
		}),
	},
};
